module.exports = __webpack_public_path__ + "img/Boy_020026.b0e300c6.png";